import { render } from "./Card.vue?vue&type=template&id=26878428&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=26878428&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26878428"

export default script